import React from "react";
import { clamp, getDefaultDraft, toSecondsMsLabel } from "./builderUtils";
import '../../styles.css'
import { toast } from "react-toastify";

function CheckboxRow({ checked, onChange, children }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginTop: 8
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        style={{ width: 16, height: 16 }}
      />
      <span>{children}</span>
    </div>
  );
}


export function BuilderDrawerForm({
  draft,
  setDraft,
  previewRef,
  isMediaAccordionOpen,
  setIsMediaAccordionOpen,
  setDraftPosition,
  setFormError,
  onLocalImagePicked,
  dragDropSlots,
  dragDropItems,
  formError,
  editingInteractionId,
  addInteraction,
  askDeleteEditingInteraction,
  onDraftTimeChange
}) {
  const totalMs = Math.max(0, Math.round(draft.timeSec * 1000));
  const minutePart = Math.floor(totalMs / 60000);
  const secondPart = Math.floor((totalMs % 60000) / 1000);
  const milliPart = totalMs % 1000;
  return (
    <>
      <div className="grid two">
      <div>
  <label>Tür</label>
  <select
    value={draft.type}
    style={{ width: "100%", height: 46 }}
    onChange={(e) => {
      const value = e.target.value;

      const nextType = value;
      const nextDraft = getDefaultDraft(nextType);
      nextDraft.timeSec = Math.floor(
        previewRef.current?.currentTime ?? 0
      );

      setDraft(nextDraft);
      setIsMediaAccordionOpen(false);
      setDraftPosition({ xPct: 50, yPct: 50 });
      setFormError("");
    }}
  >
    <option value="multiple_choice">Çoktan Seçmeli</option>
    <option value="true_false">Doğru / Yanlış</option>
    <option value="fill_blank">Boşluk Doldurma</option>
    <option value="drag_drop">Sürükle Bırak</option>
    <option value="info_hint">Bilgi / İpucu</option>
    <option value="word_bank_fill">Cümle Kelime Yerleştirme</option>
  </select>
</div>
        <div>
        <div className="time-trigger-header">
    <span className="label">Tetikleme Zamanı</span>
    <span className="time-value">{toSecondsMsLabel(draft.timeSec)}</span>
  </div>

          <div className="grid three">
            <label>
              Dakika
              <input
                type="number"
                min={0}
                step={1}
                value={minutePart}
                onChange={(e) => {
                  const value = e.target.value
                  const nextMinute = Math.max(0, Math.floor(Number(value|| 0)));
                  const nextTimeSec =
                    (nextMinute * 60000 + secondPart * 1000 + milliPart) / 1000;
                  setDraft((prev) => ({
                    ...prev,
                    timeSec: nextTimeSec
                  }));
                  onDraftTimeChange(nextTimeSec);
                }}
              />
            </label>
            <label>
              Saniye
              <input
                type="number"
                min={0}
                max={59}
                step={1}
                value={secondPart}
                onChange={(e) => {
                  const value = e.target.value
                  const rawSecond = Number(value || 0);
                  const nextSecond = clamp(Math.floor(rawSecond), 0, 59);
                  const nextTimeSec =
                  (minutePart * 60000 + nextSecond * 1000 + milliPart) / 1000;
                setDraft((prev) => ({
                  ...prev,
                  timeSec: nextTimeSec
                }));
                onDraftTimeChange(nextTimeSec);
                }}
              />
            </label>
            <label>
              Milisaniye
              <input
                type="number"
                min={0}
                max={999}
                step={1}
                value={milliPart}
                onChange={(e) => {
                  const value = e.target.value
                  const rawMs = Number(value || 0);
                  const nextMs = clamp(Math.floor(rawMs), 0, 999);
                  const nextTimeSec =
                    (minutePart * 60000 + secondPart * 1000 + nextMs) / 1000;
                  setDraft((prev) => ({
                    ...prev,
                    
                    timeSec: nextTimeSec
                  }));
                  onDraftTimeChange(nextTimeSec);
                }}
              />
            </label>
          </div>
        </div>
      </div>

      <label>
        {draft.type === "info_hint"
          ? "Bilgi / İpucu Metni"
          : draft.type === "word_bank_fill"
          ? "Yönerge"
          : draft.type === "fill_blank"
          ? "Cümle Metni"
          : "Soru Metni"}
        <textarea
          rows={2}
          value={draft.prompt}
          onChange={(e) => {
            const value = e.target.value;
            setDraft((prev) => ({ ...prev, prompt: value }));
          }}
        />
        <span className="muted">
          Biçimlendirme: <code>[u]altı çizili[/u]</code>,{" "}
          <code>[b]kalın[/b]</code>, <code>[i]italik[/i]</code>
        </span>
      </label>
      {draft.type !== "info_hint" && (
        <label>
          Açıklama Metni ("Cevabı Göster" tıklanınca görünür)
          <textarea
            rows={2}
            value={draft.revealText}
            onChange={(e) => {
              const value = e.target.value; // ✅ capture immediately
              setDraft((prev) => ({ ...prev, revealText: value }));
            }}
            placeholder="Doğru cevabın neden doğru olduğunu açıklayın."
          />
        </label>
      )}

      <div className="media-builder">
        <button
          type="button"
          className="media-accordion-toggle"
          onClick={() => setIsMediaAccordionOpen((prev) => !prev)}
          aria-expanded={isMediaAccordionOpen}
        >
          <span>Görsel Alanı (isteğe bağlı)</span>
          <span aria-hidden>{isMediaAccordionOpen ? "▾" : "▸"}</span>
        </button>
        {isMediaAccordionOpen && (
          <div className="media-accordion-content">
            <label>
              Arka Plan Görseli (yerelden yükle)
              <input
                  type="file"
                  accept=".png,image/png"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (!file) return;

                    if (file.type !== "image/png") {
                      toast.error("Sadece PNG formatında görsel yükleyebilirsiniz.");
                      e.target.value = ""; // clears filename
                      return;
                    }

                    if (file.size > 300 * 1024) {
                      toast.error("Görsel boyutu en fazla 300 KB olabilir.");
                      e.target.value = ""; // clears filename
                      return;
                    }

                    void onLocalImagePicked("backgroundImageUrl", file);
                  }}
                />
            </label>
            <label>
              Arka Plan Görsel URL
              <input
                value={draft.backgroundImageUrl ?? ""}
                onChange={(e) =>{
                  const value = e.target.value
                  setDraft((prev) => ({
                    ...prev,
                    backgroundImageUrl: value,
                  }))
                }
              }
                placeholder="https://.../background.jpg"
              />
            </label>
            {draft.backgroundImageUrl && (
              <div className="media-preview-block">
                <img
                  src={draft.backgroundImageUrl}
                  alt="Arka plan önizleme"
                  className="media-preview-image"
                />
                <button
                  onClick={() =>
                    setDraft((prev) => ({ ...prev, backgroundImageUrl: "" }))
                  }
                >
                  Arka Planı Kaldır
                </button>
              </div>
            )}
            <label>
              Örnek Görsel (yerelden yükle)
              <input
                type="file"
                accept=".png,image/png"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (!file) return;

                  // Type check
                  if (file.type !== "image/png") {
                    toast.error("Sadece PNG formatında görsel yükleyebilirsiniz.");
                    e.target.value = ""; // clear invalid selection
                    return;
                  }

                  // Size check (300 KB)
                  if (file.size > 300 * 1024) {
                    toast.error("Görsel boyutu en fazla 300 KB olabilir.");
                    e.target.value = ""; // clear invalid selection
                    return;
                  }

                  void onLocalImagePicked("exampleImageUrl", file);
                }}
              />
            </label>
            <label>
              Örnek Görsel URL
              <input
                value={draft.exampleImageUrl ?? ""}
                onChange={(e) =>{
                  const value = e.target.value
                  setDraft((prev) => ({
                    ...prev,
                    exampleImageUrl: value,
                  }))
                }
              }
                placeholder="https://.../example.png"
              />
            </label>
            {draft.exampleImageUrl && (
              <div className="media-preview-block">
                <img
                  src={draft.exampleImageUrl}
                  alt="Örnek görsel önizleme"
                  className="media-preview-image"
                />
                <button
                  onClick={() =>
                    setDraft((prev) => ({ ...prev, exampleImageUrl: "" }))
                  }
                >
                  Örnek Görseli Kaldır
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {draft.type === "word_bank_fill" && (
        <>
          <label>
            Cümle Metni (doğru kelimeleri yıldız içinde yazın)
            <textarea
              rows={4}
              value={draft.wordBankSentenceText}
              onChange={(e) =>{
                const value = e.target.value
                setDraft((prev) => ({
                  ...prev,
                  wordBankSentenceText: value,
                }))
              }
            }
              placeholder="*Oslo* Norveç'in başkentidir."
            />
            <span className="muted">
              Örnek: <code>*Oslo*</code> ve <code>*Ankara*</code> doğru
              kelimeleri boşluklara dönüştürür.
            </span>
          </label>
          <label>
            Dikkat Dağıtıcı Kelimeler (her satıra bir tane)
            <textarea
              rows={3}
              value={draft.wordBankDistractorsText}
              onChange={(e) =>{
                const value = e.target.value
                setDraft((prev) => ({
                  ...prev,
                  wordBankDistractorsText: value,
                }))
              }
            }
              placeholder={"Stockholm\nBerlin"}
            />
          </label>
        </>
      )}

      {draft.type === "info_hint" && (
        <label>
          Görünme Süresi (saniye)
          <input
            type="number"
            min={1}
            step={1}
            value={draft.hintDurationSec}
            onChange={(e) =>{
              const value = e.target.value
              setDraft((prev) => ({
                ...prev,
                hintDurationSec: Number(value || 10),
              }))
            }
          }
          />
          <span className="muted">
            İpucu videoyu durdurmaz; seçtiğiniz saniyede görünür ve süre bitince
            otomatik kapanır.
          </span>
        </label>
      )}

      {draft.type === "multiple_choice" && (
        <>
          <label>
            Doğru Cevap Modu
            <select
              value={draft.mcSelectionMode}
              onChange={(e) =>{
                const value = e.target.value
                setDraft((prev) => ({
                  ...prev,
                  mcSelectionMode: value,
                }))
              }
            }
            >
              <option value="single">Tek Doğru</option>
              <option value="multiple">Çoklu Doğru</option>
            </select>
          </label>
          <div className="mc-builder-list">
            {draft.mcOptions.map((option, idx) => (
              <div className="mc-builder-item" key={`mc_opt_${idx}`}>
                <div className="mc-builder-item-head">
                  <strong>Seçenek {idx + 1}</strong>
                  <button
                    onClick={() =>
                      setDraft((prev) => ({
                        ...prev,
                        mcOptions: prev.mcOptions.filter((_, i) => i !== idx),
                      }))
                    }
                    disabled={draft.mcOptions.length <= 2}
                  >
                    Sil
                  </button>
                </div>
                <label>
                  Metin
                  <input
                    value={option.text}
                    placeholder="Örn: [u]Ankara[/u] yanlış yazılmıştır."
                    onChange={(e) =>{
                      const value = e.target.value
                      setDraft((prev) => ({
                        ...prev,
                        mcOptions: prev.mcOptions.map((opt, i) =>
                        i === idx ? { ...opt, text: value } : opt
                        ),
                      }))
                    }
                  }
                  />
                </label>
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={option.isCorrect}
                    onChange={(e) => {
                      const checked = e.target.checked; // ✅ capture before setDraft

                      setDraft((prev) => {
                        const next = prev.mcOptions.map((opt, i) =>
                          i === idx ? { ...opt, isCorrect: checked } : opt
                        );

                        if (prev.mcSelectionMode === "single" && checked) {
                          return {
                            ...prev,
                            mcOptions: next.map((opt, i) =>
                              i === idx ? opt : { ...opt, isCorrect: false }
                            ),
                          };
                        }

                        return { ...prev, mcOptions: next };
                      });
                    }}
                  />
                  Doğru seçenek
                </label>
                <label>
                  İpucu metni (kontrol öncesi)
                  <input
                    value={option.tipText}
                    onChange={(e) =>{
                      const value = e.target.value
                      setDraft((prev) => ({
                        ...prev,
                        mcOptions: prev.mcOptions.map((opt, i) =>
                        i === idx ? { ...opt, tipText: value } : opt
                        ),
                      }))
                    }
                  }
                  />
                </label>
                <label>
                  Seçilirse gösterilecek geri bildirim
                  <input
                    value={option.selectedFeedback}
                    onChange={(e) =>{
                      const value = e.target.value
                      setDraft((prev) => ({
                        ...prev,
                        mcOptions: prev.mcOptions.map((opt, i) =>
                        i === idx
                        ? { ...opt, selectedFeedback: value }
                        : opt
                        ),
                      }))
                    }
                  }
                  />
                </label>
                <label>
                  Seçilmezse gösterilecek geri bildirim
                  <input
                    value={option.unselectedFeedback}
                    onChange={(e) =>{
                      const value = e.target.value
                      setDraft((prev) => ({
                        ...prev,
                        mcOptions: prev.mcOptions.map((opt, i) =>
                        i === idx
                        ? { ...opt, unselectedFeedback: value }
                        : opt
                        ),
                      }))
                    }
                  }
                  />
                </label>
              </div>
            ))}
            <button
              onClick={() =>
                setDraft((prev) => ({
                  ...prev,
                  mcOptions: [
                    ...prev.mcOptions,
                    {
                      text: "",
                      isCorrect: false,
                      tipText: "",
                      selectedFeedback: "",
                      unselectedFeedback: "",
                    },
                  ],
                }))
              }
            >
              Seçenek Ekle
            </button>
          </div>
        </>
      )}

      {draft.type === "true_false" && (
        <label>
          Doğru Cevap
          <select
            value={String(draft.trueFalseCorrect)}
            onChange={(e) =>{
              const value = e.target.value
              setDraft((prev) => ({
                ...prev,
                trueFalseCorrect: value === "true",
              }))
            }
          }
          >
            <option value="true">Doğru</option>
            <option value="false">Yanlış</option>
          </select>
        </label>
      )}

      {draft.type === "fill_blank" && (
        <div className="media-builder">
          <p className="drag-map-title">Boşluk Yazım Kuralı</p>
          <p className="muted">
            Boşluk olacak kelimeyi yıldız içine alın: <code>*Ankara*</code>.
          </p>
          <p className="muted">
            Aynı boşluk için kabul edilecek alternatifleri <code>|</code> ile
            yazın: <code>*Ankara|ankra|ankaraa*</code>
          </p>
          <p className="muted">
            Birden fazla boşluk için cümlede birden çok yıldızlı alan kullanın.
          </p>
        </div>
      )}

      {draft.type === "drag_drop" && (
        <>
          <label>
            Satır Başlıkları (her satıra bir tane)
            <textarea
              rows={4}
              value={draft.dragDropSlotsText}
              onChange={(e) =>{
                const value = e.target.value
                setDraft((prev) => ({
                  ...prev,
                  dragDropSlotsText: value,
                }))
              }
            }
            />
          </label>
          <label>
            Sürüklenebilir Öğeler (her satıra bir tane)
            <textarea
              rows={5}
              value={draft.dragDropItemsText}
              onChange={(e) =>{
                const value = e.target.value
                setDraft((prev) => ({
                  ...prev,
                  dragDropItemsText: value,
                }))
              }
            }
            />
          </label>
          <div className="drag-map-builder">
            <p className="drag-map-title">Doğru Eşleştirme (görsel)</p>
            {dragDropSlots.length === 0 || dragDropItems.length === 0 ? (
              <p className="muted">
                Eşleştirme için en az bir satır ve bir öğe ekleyin.
              </p>
            ) : (
              <>
                {dragDropSlots.map((slot, slotIdx) => (
                  <div className="drag-map-row" key={slot + slotIdx}>
                    <div className="drag-map-slot">{slot}</div>
                    <div className="drag-map-items">
                      {dragDropItems.map((item, itemIdx) => {
                        const inSlot = (
                          draft.dragDropCorrectMap[slotIdx] ?? []
                        ).includes(itemIdx);
                        const usedByOtherSlot = draft.dragDropCorrectMap.some(
                          (mappedGroup, mappedSlotIdx) =>
                            mappedSlotIdx !== slotIdx &&
                            mappedGroup.includes(itemIdx)
                        );
                        return (
                          <button
                            key={item + itemIdx}
                            className={`drag-map-item ${
                              inSlot ? "is-selected" : ""
                            }`}
                            disabled={usedByOtherSlot}
                            onClick={() =>
                              setDraft((prev) => {
                                const next = prev.dragDropCorrectMap.map(
                                  (group) => [...group]
                                );
                                const group = next[slotIdx] ?? [];
                                const exists = group.includes(itemIdx);
                                next[slotIdx] = exists
                                  ? group.filter((v) => v !== itemIdx)
                                  : [...group, itemIdx];
                                return { ...prev, dragDropCorrectMap: next };
                              })
                            }
                          >
                            {item}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                ))}
                {dragDropSlots.some(
                  (_, slotIdx) =>
                    (draft.dragDropCorrectMap[slotIdx] ?? []).length === 0
                ) && (
                  <p className="muted">
                    Bu etkileşimi eklemeden önce her satır için bir veya daha
                    fazla doğru öğe seçin.
                  </p>
                )}
              </>
            )}
          </div>
        </>
      )}




<div style={{ marginTop: 12 }}>
  <CheckboxRow
    checked={draft.enableRetry}
    onChange={(checked) =>
      setDraft((prev) => ({
        ...prev,
        enableRetry: checked
      }))
    }
  >
    Tekrar Denemeye İzin Ver
  </CheckboxRow>

  <CheckboxRow
    checked={draft.showSolution}
    onChange={(checked) =>
      setDraft((prev) => ({
        ...prev,
        showSolution: checked
      }))
    }
  >
    Doğru Cevabı Göster
  </CheckboxRow>
</div>



      {formError && <p className="form-error">{formError}</p>}

      <div className="bd-footer">
    <div className="bd-button-row">
      <button className="primary" onClick={addInteraction}>
        {editingInteractionId ? "Güncelle" : "Etkileşim Ekle"}
      </button>

      {editingInteractionId && (
        <button
          type="button"
          className="danger-button"
          onClick={askDeleteEditingInteraction}
        >
          Etkileşimi Sil
        </button>
      )}
    </div>
  </div>
    </>
  );
}
